import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
} from "@heroui/react";
import { Icon } from "@iconify/react";

import { TariffCategoryEntity } from "@/features/tariffs/types.ts";
import { EditTariffVisibilitySwitch } from "@/features/tariffs/categories/ui/edit-tariff-visibility-switch.tsx";
import { EditTariffCategoryModal } from "@/features/tariffs/categories/ui/edit-tariff-category-modal.tsx";
import { DeleteTariffCategoryModal } from "@/features/tariffs/categories/ui/delete-tariff-category-modal.tsx";

export const TariffCategoryTableOptions = ({
  tariffCategory,
}: {
  tariffCategory: TariffCategoryEntity;
}) => {
  const navigate = useNavigate();
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);

  return (
    <>
      <Dropdown>
        <Dropdown.Trigger>
          <Button isIconOnly size="sm" variant="ghost">
            <Icon className="size-6" icon="solar:menu-dots-bold" />
          </Button>
        </Dropdown.Trigger>
        <Dropdown.Popover>
          <DropdownMenu
            onAction={(event) => {
              if (event === "tariffs")
                navigate({
                  to: `/dashboard/categories/$categoryId`,
                  params: {
                    categoryId: tariffCategory.id.toString(),
                  },
                });
              if (event === "edit") setIsEditModalOpen(true);
              if (event === "delete") setIsDeleteModalOpen(true);
            }}
          >
            <DropdownItem id="tariffs" textValue="tariffs">
              <Icon className="size-6" icon="solar:arrow-right-linear" />
              Тарифы
            </DropdownItem>
            <DropdownItem id="edit" textValue="edit">
              <Icon className="size-6" icon="solar:pen-bold-duotone" />
              Изменить
            </DropdownItem>
            <DropdownItem id="visibility" textValue="visibility">
              <EditTariffVisibilitySwitch tariffCategory={tariffCategory} />
            </DropdownItem>
            <DropdownItem id="delete" textValue="delete">
              <Icon
                className="size-6"
                icon="solar:trash-bin-minimalistic-bold"
              />
              Удалить
            </DropdownItem>
          </DropdownMenu>
        </Dropdown.Popover>
      </Dropdown>

      <EditTariffCategoryModal
        isOpen={isEditModalOpen}
        setIsOpen={setIsEditModalOpen}
        tariffCategoryId={tariffCategory.id}
      />

      <DeleteTariffCategoryModal
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        tariffCategoryId={tariffCategory.id}
      />
    </>
  );
};
